module.exports = __webpack_public_path__ + "img/mon-5.70f502e9.png";